import * as React from 'react'

import { ServiceCheckbox } from './ServiceCheckbox'
import type { CheckboxOption, CheckedHandler } from '../typings'

export type ScheduleEstimateProps = {
  onChange: CheckedHandler
  serviceOptions: CheckboxOption[]
}

export function ScheduleEstimate(props: ScheduleEstimateProps) {
  const { onChange, serviceOptions } = props

  return (
    <>
      {serviceOptions.map((s) => (
        <ServiceCheckbox key={s.id} service={s} onChange={onChange} />
      ))}
    </>
  )
}
